import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { CurrencyPound } from '@mui/icons-material';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { CreatePartnerPriceInput } from '__generated__/graphql';
import { useCreatePartnerPrice } from 'api/hooks/usePartnerPrice';
import { LocationBar } from 'components';
import { useUser } from 'context/userContext';
import { useToastNofication } from 'context/toastContext';
import { PartnerPriceForm } from './MyPriceForm';

function MyPriceCreateForm() {
  const { partner } = useUser();
  const { addToast } = useToastNofication();

  const { createPartnerPrice, createPartnerPriceLoading, createPartnerPriceError } = useCreatePartnerPrice(partner?.id || '');
  const navigate = useNavigate();

  const onSubmit = async (input: CreatePartnerPriceInput) => {
    const response = await createPartnerPrice({
      variables: {
        input,
      },
    });
    addToast(response, 'CreatePartnerPrice');

    if (!createPartnerPriceLoading && !createPartnerPriceError) {
      navigate('/my-prices');
    }
  };

  const onBack = () => {
    navigate('/my-prices');
  };

  return (
    <>
      <Helmet>
        <title>Price Create</title>
      </Helmet>
      <LocationBar section="Partner" page="Price Create Form" Icon={CurrencyPound} />
      <div className="my-10 px-4 md:px-[5%]">
        <button data-cy="form-detail-back" type="button" className="text-gray-500 font-semibold text-md leading-md flex items-center" onClick={onBack}>
          <ArrowLeftIcon className="mr-2 w-5 h-5" /> Back
        </button>
        <PartnerPriceForm onSubmit={onSubmit} formSubmitting={createPartnerPriceLoading} formSubmitError={createPartnerPriceError} />
      </div>
    </>
  );
}

export default MyPriceCreateForm;
